
// const
//     body = $('body'),
//     cartSummary = $('.cart__summary'),
//     disclaimerBox = $('.subscribe-box__disclaimer'),
//     disclaimerTrigger = $('.subscribe-box__title'),
//     subscribeMode = $('.purchaseMode'),
//     closeDisclaimer = $('.closeDisclaimer'),
//     cta = $('.cta[data-param]:not(#vslCTA)');

// //- Select Subscribe option if click on disclaimer box title
// disclaimerTrigger.on("click", function () {
//     let cart = $(this).closest('.cart'),
//         checkbox = cart.find($('.subscribe-box__checked')),
//         cartBtn = cart.find('.cta[data-param]:not(#vslCTA)');

//     checkbox.toggleClass('checked');
//     cartBtn.toggleClass('disabled');

//     if (checkbox.hasClass('alert')) {
//         cart.find($('.subscribe-box__alert')).removeClass('show');
//         checkbox.removeClass('alert');
//     }
// })

// // Detect Touch event
// if ("ontouchstart" in document.documentElement) {
//     body.addClass('touch');

//     let cart = $(this).closest('.cart');

//     // close disclaimer box
//     closeDisclaimer.on('click', function () {
//         cart.find('.subscribe-box__disclaimer').addClass('hide').removeClass('show');
//     });
// }

// // close disclaimer box
// closeDisclaimer.on('click', function () {
//     let cart = $(this).closest('.cart');

//     cart.find('.subscribe-box__disclaimer').removeClass('subscribe-box__disclaimer--open');
// });

// // Subscribe Mode
// $('.subscribe-box__default').on('click', function () {
//     let thisBtn = $(this),
//         cart = thisBtn.closest('.cart'),
//         cartBtn = cart.find('.cta[data-param]:not(#vslCTA)');
//     checkbox = cart.find($('.subscribe-box__checked'));

//     $('.subscribe-box__default').removeClass('active');
//     thisBtn.addClass('active');

//     cart.find('.subscribe-box__disclaimer').addClass('subscribe-box__disclaimer--open');

//     //- reset all UIs
//     if (cartBtn.hasClass('disabled')) {
//         cartBtn.removeClass('disabled');
//     }

//     if (checkbox.hasClass('checked')) {
//         checkbox.removeClass('checked');
//     }

//     //- set 'data-subscribe' value + control UI
//     if (thisBtn.hasClass('subscribe')) {
//         cart.find('.purchaseMode').attr('data-subscribe', 'true');

//         cart.find('.cart__summary').addClass('cart__summary--subscribe');

//         if ($(body).hasClass('show-promoBanner')) {
//             body.addClass('show-promoBanner--club');
//         }

//         if (!cartBtn.hasClass('disabled')) {
//             cartBtn.addClass('disabled');
//         }

//         if (!cart.find('.subscribe-box__disclaimer').hasClass('subscribe-box__disclaimer--open')) {
//             cart.find('.subscribe-box__disclaimer').addClass('subscribe-box__disclaimer--open');
//         }

//         // on touch screens
//         if ("ontouchstart" in document.documentElement && cart.find('.subscribe-box__disclaimer').hasClass('hide')) {
//             cart.find('.subscribe-box__disclaimer').removeClass('hide').addClass('show');
//         }

//     } else {
//         cart.find('.purchaseMode').attr('data-subscribe', 'false');

//         cart.find('.cart__summary').removeClass('cart__summary--subscribe');

//         if ($(body).hasClass('show-promoBanner')) {
//             body.removeClass('show-promoBanner--club');
//         }

//         if (cartBtn.hasClass('disabled')) {
//             cartBtn.removeClass('disabled');
//         }

//         if (cart.find('.subscribe-box__disclaimer').hasClass('subscribe-box__disclaimer--open')) {
//             cart.find('.subscribe-box__disclaimer').removeClass('subscribe-box__disclaimer--open');
//         }

//         // on touch screens
//         if ("ontouchstart" in document.documentElement && cart.find('.subscribe-box__disclaimer').hasClass('show')) {
//             cart.find('.subscribe-box__disclaimer').removeClass('show').addClass('hide');
//         }
//     }

//     cart.find('.cart__product.active').trigger("click");
// });

// /**
//  * Subscribe Mode - chechbox mode
//  */
// $('.purchaseMode__input').on('click', function (check) {
//     // console.log($(this).is(":checked"));

//     let checkboxType;
//     let cart = $(this).closest('.cart'),
//         cartBtn = cart.find('.cta[data-param]:not(#vslCTA)');

//     if (cart.attr('data-subscribe') === 'false') {
//         checkboxType = true;

//         // console.log($(this));

//         subscribeOn($(this));

//         // if(ctaSubscribeAndSaveText != '') {
//         //     cart.find('.cta[data-param]:not(#vslCTA)').html(ctaSubscribeAndSaveText);
//         // }

//         cart.find('.cart__summary').addClass('cart__summary--subscribe');

//         if (cart.find('.purchaseMode').length) {
//             cartBtn.addClass('disabled');
//         }

//     } else {
//         checkboxType = false;

//         subscribeOff($(this));

//         cart.find('.cart__summary').removeClass('cart__summary--subscribe');

//         if (cart.find('.purchaseMode').length) {
//             cartBtn.removeClass('disabled');

//             //- Reset S&S click on disable alert
//             if (cart.find('.subscribe-box__checked').hasClass('alert')) {
//                 cart.find('.subscribe-box__alert').removeClass('show');
//                 cart.find('.subscribe-box__checked').removeClass('alert');
//             }

//             if (cart.find('.subscribe-box__checked').hasClass('checked')) {
//                 cart.find('.subscribe-box__checked').removeClass('checked');
//             }
//         }
//     }

//     this.setAttribute('checked', checkboxType);

//     cart.find('.cart__product.active').trigger("click");

//     console.log("trigger('click')", 1)
// });

// function subscribeOn(el) {
//     let cart = el.closest('.cart');

//     cart.attr('data-subscribe', 'true');
//     el.parent().parent().attr('data-subscribe', 'true');
//     el.parent().parent().next('.subscribe-box__disclaimer').addClass('subscribe-box__disclaimer--open');

//     if ($(body).hasClass('show-promoBanner')) {
//         body.addClass('show-promoBanner--club');
//     }

//     //- fix to which .cart should scroll
//     setTimeout(function () {
//         cart.find('.cart__products').slick("refresh");
//     }, 150);

//     $('html, body').animate({
//         scrollTop: el.closest(".cart").offset().top
//     }, 100);
// }

// function subscribeOff(el) {
//     let cart = el.closest('.cart');

//     cart.attr('data-subscribe', 'false')
//     el.closest(subscribeMode).attr('data-subscribe', 'false');

//     // on touch screens
//     if (disclaimerBox.hasClass('subscribe-box__disclaimer--open')) {
//         disclaimerBox.removeClass('subscribe-box__disclaimer--open');
//     }

//     if ($(body).hasClass('show-promoBanner')) {
//         body.removeClass('show-promoBanner--club');
//     }

//     setTimeout(function () {
//         cart.find('.cart__products').slick("refresh");
//     }, 150);
// }

// function activeProduct() {
//     let thisProduct = $(this);
//     let cart = thisProduct.closest('.cart');
//     let subscribeAttr = cart.find('.purchaseMode').attr('data-subscribe');
//     let unit = thisProduct.attr('data-units');
//     let ribbon = thisProduct.attr('data-ribbon');

//     // const btnUnitsValue = $('#btnUnitsValue');

//     // console.log('thisProduct', thisProduct);
//     // console.log('subscribeAttr', subscribeAttr);
//     // console.log('unit', unit);

//     let price, retail, saving, link, subscription, sale, shipping;

//     price = 'amount';
//     retail = 'retail';
//     saving = 'saving';
//     link = 'tracker';
//     sale = '';
//     shipping = 'shipping';

//     if (subscribeAttr === 'true') {
//         subscription = 'club-';

//     } else {
//         subscription = '';
//     }

//     if ($('body').hasClass('show-promoBanner')) {
//         sale = 'sale-'

//     } else {
//         sale = '';
//     }

//     // console.log('data-' + sale + subscription + price);

//     $('.cart__product').removeClass('active');
//     thisProduct.addClass('active');

//     if (!$('.cart--centeredSlides').length) {
//         thisProduct.find('.current__value').html(thisProduct.attr('data-' + sale + subscription + price + ''));
//         thisProduct.find('.retail__value').html(thisProduct.attr('data-' + sale + subscription + retail + ''));
//         thisProduct.find('.internet__value').html(thisProduct.attr('data-' + price + ''));
//         thisProduct.find('.saving__value').html(thisProduct.attr('data-' + sale + subscription + saving + ''));
//     } else {
//         $('.cart__product').each(function () {
//             thisProduct.find('.current__value').html(thisProduct.attr('data-' + sale + subscription + price + ''));
//             thisProduct.find('.retail__value').html(thisProduct.attr('data-' + sale + subscription + retail + ''));
//             thisProduct.find('.internet__value').html(thisProduct.attr('data-' + price + ''));
//             thisProduct.find('.saving__value').html(thisProduct.attr('data-' + sale + subscription + saving + ''));
//         });

//         thisProduct.find('.cart__shipping').html(thisProduct.attr('data-' + subscription + shipping + ''));
//     }

//     //- print ribbon value
//     if (thisProduct.find('.ribbon').length) {
//         thisProduct.find('.ribbon__value').html(ribbon);
//     }

//     // btnUnitsValue.html(unit);

//     // Images to show according to the product unit
//     thisProduct.find('.cart__image-item').removeClass('show').addClass('hide');
//     thisProduct.find('.cart__image-item--' + unit + '').removeClass('hide').addClass('show');

//     // btnUnitsValue.html(unit);

//     //- handle CTA by ID
//     let param = cart.find('.cta[data-param]:not(#vslCTA)').attr('data-param');

//     cart.find('.cta[data-param]:not(#vslCTA)').attr('href', thisProduct.attr('data-' + sale + subscription + link + '') + param);

//     /**
//      * Calculate Price Per Day
//      */
//     let pricePerDay,
//         month = 30,
//         days,
//         amount = thisProduct.attr('data-' + sale + subscription + price + '');

//     function calcPricePerDay(amount, unit, month) {
//         // console.log('amount', amount);
//         // console.log('unit', unit);
//         // console.log('month', month);

//         //- Split amount and convert into number
//         let amountNum = amount.replace('$', '');

//         //- Calculate months into days
//         days = unit * month;
//         // console.log('days', days);

//         pricePerDay = (amountNum / days).toFixed(2);

//         // console.log('pricePerDay', pricePerDay);

//         thisProduct.find('.price-per-day__value').html('$' + pricePerDay);

//     }

//     calcPricePerDay(amount, unit, month);
// };

// $('.cart__product').on('click', activeProduct);
// $('.cart__product.active').trigger("click");

// console.log("trigger('click')", 2)

// /**
//  * Activate slider when cart_layout_options == 'centered-card-slides'
//  */
// if ($('.cart--centeredSlides').length) {
//     $('.cart__products').slick({
//         infinite: false,
//         centerMode: true,
//         mobileFirst: true,
//         arrows: false,
//         responsive: [
//             {
//                 breakpoint: 0,
//                 settings: {
//                     slidesToShow: 1,
//                     centerPadding: '30px'
//                 }
//             },
//             {
//                 breakpoint: 374,
//                 settings: {
//                     slidesToShow: 1,
//                     centerPadding: '80px'
//                 }
//             },
//             {
//                 breakpoint: 767,
//                 settings: {
//                     slidesToShow: 3,
//                     centerPadding: '50px'
//                 }
//             },
//             {
//                 breakpoint: 992,
//                 settings: {
//                     slidesToShow: 3,
//                     centerPadding: '80px'
//                 }
//             }
//         ]
//     });

//     let initialRun = false;

//     if (!false && $(window).width() < 768) {
//         const currentActiveCard = parseInt($('.cart__product').get().map((item, index) => $(item).hasClass('active') ? index : '').join(''));

//         $('.cart__products').slick('slickGoTo', currentActiveCard);

//         initialRun = true;
//     }

//     $('.cart__products').on('setPosition', function () {
//         if ($(window).width() <= 768) {
//             const currentActiveCard = parseInt($('.cart__product').get().map((item, index) => $(item).hasClass('active') ? index : '').join(''));
//             const slickActiveCard = parseInt($('.cart__product').get().map((item, index) => $(item).hasClass('slick-center') ? index : '').join(''));

//             $('.cart__product').removeClass('active');
//             $('.cart__product').eq(currentActiveCard).addClass('active');
//             $('.cart__product.active').trigger("click");

//             if (slickActiveCard != currentActiveCard) {
//                 $('.cart__product').removeClass('active');
//                 $('.cart__product').eq(slickActiveCard).addClass('active');
//                 $('.cart__product.active').trigger("click");
//             }
//         }
//     });

//     $('.cart__products').on('click', function () {
//         if ($(window).width() < 768) {
//             const currentActiveCard = parseInt($('.cart__product').get().map((item, index) => $(item).hasClass('active') ? index : '').join(''));
//             const slickActiveCard = parseInt($('.cart__product').get().map((item, index) => $(item).hasClass('slick-center') ? index : '').join(''));

//             if (slickActiveCard != currentActiveCard) {
//                 $('.cart__products').slick('slickGoTo', currentActiveCard);
//             }
//         }
//     });
// }

const
    body = $('body'),
    cartSummary = $('.cart__summary'),
    disclaimerBox = $('#disclaimerBox'),
    disclaimerTrigger = $('#disclaimerTrigger'),
    subscribeMode = $('.purchaseMode'),
    subscribeModeDoubleSS = $('#subscribeModeDoubleSS');

//- Select Subscribe option if click on disclaimer box title
disclaimerTrigger.on("click", function () {
    let checkbox = $('#subscribeCheckbox');
    let cartBtn = $('#cartCta');

    checkbox.toggleClass('checked');
    cartBtn.toggleClass('disabled');

    if (checkbox.hasClass('alert')) {
        $('.subscribe-box__alert').removeClass('show');
        checkbox.removeClass('alert');
    }
})

// Detect Touch event
if ("ontouchstart" in document.documentElement) {
    body.addClass('touch');

    // close disclaimer box
    $('#closeDisclaimer').on('click', function () {
        disclaimerBox.addClass('hide').removeClass('show');
    });
}

// close disclaimer box
$('#closeDisclaimer').on('click', function () {
    disclaimerBox.removeClass('subscribe-box__disclaimer--open');
});

// Subscribe Mode
$('.subscribe-box__default').on('click', function () {
    let thisBtn = $(this),
        cartBtn = $('#cartCta'),
        checkbox = $('#subscribeCheckbox');

    $('.subscribe-box__default').removeClass('active');
    thisBtn.addClass('active');

    disclaimerBox.addClass('subscribe-box__disclaimer--open');

    //- reset all UIs
    if (cartBtn.hasClass('disabled')) {
        cartBtn.removeClass('disabled');
    }

    if (checkbox.hasClass('checked')) {
        checkbox.removeClass('checked');
    }

    //- set 'data-subscribe' value + control UI
    if (thisBtn.hasClass('subscribe')) {
        subscribeMode.attr('data-subscribe', 'true');

        cartSummary.addClass('cart__summary--subscribe');

        if ($(body).hasClass('show-promoBanner')) {
            body.addClass('show-promoBanner--club');
        }

        if (!cartBtn.hasClass('disabled')) {
            cartBtn.addClass('disabled');
        }

        if (!disclaimerBox.hasClass('subscribe-box__disclaimer--open')) {
            disclaimerBox.addClass('subscribe-box__disclaimer--open');
        }

        // on touch screens
        if ("ontouchstart" in document.documentElement && disclaimerBox.hasClass('hide')) {
            disclaimerBox.removeClass('hide').addClass('show');
        }

    } else {
        subscribeMode.attr('data-subscribe', 'false');

        cartSummary.removeClass('cart__summary--subscribe');

        if ($(body).hasClass('show-promoBanner')) {
            body.removeClass('show-promoBanner--club');
        }

        if (cartBtn.hasClass('disabled')) {
            cartBtn.removeClass('disabled');
        }

        if (disclaimerBox.hasClass('subscribe-box__disclaimer--open')) {
            disclaimerBox.removeClass('subscribe-box__disclaimer--open');
        }

        // on touch screens
        if ("ontouchstart" in document.documentElement && disclaimerBox.hasClass('show')) {
            disclaimerBox.removeClass('show').addClass('hide');
        }
    }

    $('.cart__product.active').trigger("click");
});

/**
 * Subscribe Mode - chechbox mode
 */
$('#subscribeInput').on('click', function (check) {
    // console.log($(this).is(":checked"));

    let checkboxType;

    if ($('#orderNow').attr('data-subscribe') === 'false') {
        checkboxType = true;

        subscribeOn();

        // if(ctaSubscribeAndSaveText != '') {
        //     $('#cartCta').html(ctaSubscribeAndSaveText);
        // }

        cartSummary.addClass('cart__summary--subscribe');

        if (subscribeModeDoubleSS.length) {
            $('#cartCta').addClass('disabled');
        }

    } else {
        checkboxType = false;

        subscribeOff();

        // if(ctaSubscribeAndSaveText != '') {
        //     $('#cartCta').html(ctaText);
        // }

        cartSummary.removeClass('cart__summary--subscribe');

        if (subscribeModeDoubleSS.length) {
            $('#cartCta').removeClass('disabled');

            //- Reset S&S click on disable alert
            if ($('#subscribeCheckbox').hasClass('alert')) {
                $(".subscribe-box__alert").removeClass('show');
                $("#subscribeCheckbox").removeClass('alert');
            }

            if ($('#subscribeCheckbox').hasClass('checked')) {
                $("#subscribeCheckbox").removeClass('checked');
            }
        }
    }

    this.setAttribute('checked', checkboxType);

    $('.cart__product.active').trigger("click");
});

$('#stateSSOn').on('click', function (check) {
    subscribeOn();

    $('#subscribeInput').attr('checked', 'true');

    $('.cart__product.active').trigger("click");
})

function subscribeOn() {
    $('#orderNow').attr('data-subscribe', 'true');
    subscribeMode.attr('data-subscribe', 'true');
    disclaimerBox.addClass('subscribe-box__disclaimer--open');

    if ($(body).hasClass('show-promoBanner')) {
        body.addClass('show-promoBanner--club');
    }

    $('html, body').animate({
        scrollTop: $("#orderNow").offset().top
    }, 1000);
}

function subscribeOff() {
    $('#orderNow').attr('data-subscribe', 'false')
    subscribeMode.attr('data-subscribe', 'false');

    // on touch screens
    if (disclaimerBox.hasClass('subscribe-box__disclaimer--open')) {
        disclaimerBox.removeClass('subscribe-box__disclaimer--open');
    }

    if ($(body).hasClass('show-promoBanner')) {
        body.removeClass('show-promoBanner--club');
    }
}

function activeProduct() {
    let thisProduct = $(this);
    let subscribeAttr = $('.purchaseMode').attr('data-subscribe');
    let unit = thisProduct.attr('data-units');
    let ribbon = thisProduct.attr('data-ribbon');

    const btnUnitsValue = $('#btnUnitsValue');

    let price, retail, saving, link, subscription, sale, shipping;

    price = 'amount';
    retail = 'retail';
    saving = 'saving';
    link = 'tracker';
    sale = '';
    shipping = 'shipping';

    if (subscribeAttr === 'true') {
        subscription = 'club-';

    } else {
        subscription = '';
    }

    if ($('body').hasClass('show-promoBanner')) {
        sale = 'sale-'

    } else {
        sale = '';
    }

    // console.log('data-' + sale + subscription + price);

    $('.cart__product').removeClass('active');
    thisProduct.addClass('active');

    if (!$('.cart--centeredSlides').length) {
        $('.current__value').html(thisProduct.attr('data-' + sale + subscription + price + ''));
        $('.retail__value').html(thisProduct.attr('data-' + sale + subscription + retail + ''));
        $('.internet__value').html(thisProduct.attr('data-' + price + ''));
        $('.saving__value').html(thisProduct.attr('data-' + sale + subscription + saving + ''));
    } else {
        $('.cart__product').each(function () {
            $(this).find('.current__value').html($(this).attr('data-' + sale + subscription + price + ''));
            $(this).find('.retail__value').html($(this).attr('data-' + sale + subscription + retail + ''));
            $(this).find('.internet__value').html($(this).attr('data-' + price + ''));
            $(this).find('.saving__value').html($(this).attr('data-' + sale + subscription + saving + ''));
        });
        $('#cartShipping').html($(this).attr('data-' + subscription + shipping + ''));
    }

    //- print ribbon value
    if ($('#ribbon').length) {
        $('.ribbon__value').html(ribbon);
    }

    btnUnitsValue.html(unit);

    // Images to show according to the product unit
    $('.cart__image-item').removeClass('show').addClass('hide');
    $('.cart__image-item--' + unit + '').removeClass('hide').addClass('show');

    btnUnitsValue.html(unit);

    //- handle CTA by ID
    let param = $('#cartCta').attr('data-param');
    $('#cartCta').attr('href', thisProduct.attr('data-' + sale + subscription + link + '') + param);

    /**
     * Calculate Price Per Day
     */

    let pricePerDay,
        month = 30,
        days,
        amount = thisProduct.attr('data-' + sale + subscription + price + '');

    function calcPricePerDay(amount, unit, month) {
        // console.log('amount', amount);
        // console.log('unit', unit);
        // console.log('month', month);

        //- Split amount and convert into number
        let amountNum = amount.replace('$', '');

        //- Calculate months into days
        days = unit * month;
        // console.log('days', days);

        pricePerDay = (amountNum / days).toFixed(2);

        // console.log('pricePerDay', pricePerDay);

        $('.price-per-day__value').html('$' + pricePerDay);

    }

    calcPricePerDay(amount, unit, month);

    /**
     * Handle Strawberry Image banner when under sale mode
     */
    const bannerImgEl = $('#bannerImage'); //- define Image Element
    const bannerImgPath = 'https://dtjlhiahlv53j.cloudfront.net/assets/nucific/';
    let bannerImgD, bannerImgT, bannerImgM, bannerImgVersion;

    //- Check if we're on sale time period but not under club prices
    if ($('body').hasClass('show-promoBanner') && !$('body').hasClass('show-promoBanner--club')) {
        bannerImgD = bannerImgEl.attr('data-sale-image-d');
        bannerImgT = bannerImgEl.attr('data-sale-image-t');
        bannerImgM = bannerImgEl.attr('data-sale-image-m');

    } else {
        bannerImgD = bannerImgEl.attr('data-image-d');
        bannerImgT = bannerImgEl.attr('data-image-t');
        bannerImgM = bannerImgEl.attr('data-image-m');
    }

    //- manipulate banner image size
    if (window.innerWidth > 1024) {
        bannerImgVersion = bannerImgD;

    } else if (window.innerWidth < 768) {
        bannerImgVersion = bannerImgM;

    } else {
        bannerImgVersion = bannerImgT;
    }

    // console.log(bannerImgEl.src = bannerImgPath + bannerImg + bannerImgVersion + '.jpg');

    bannerImgEl.attr('src', bannerImgPath + bannerImgVersion);
};

$('.cart__product').on('click', activeProduct);
$('.cart__product.active').trigger("click");

/**
 * Activate slider when cart_layout_options == 'centered-card-slides'
*/
if ($('.cart--centeredSlides').length) {
    $('.cart__products').slick({
        infinite: false,
        centerMode: true,
        mobileFirst: true,
        arrows: false,
        responsive: [
            {
                breakpoint: 0,
                settings: {
                    slidesToShow: 1,
                    centerPadding: '30px'
                }
            },
            {
                breakpoint: 374,
                settings: {
                    slidesToShow: 1,
                    centerPadding: '80px'
                }
            },
            {
                breakpoint: 768,
                settings: {
                    slidesToShow: 3,
                    centerPadding: '50px'
                }
            },
            {
                breakpoint: 992,
                settings: {
                    slidesToShow: 3,
                    centerPadding: '80px'
                }
            }
        ]
    });

    let initialRun = false;
    if (!false && $(window).width() < 768) {
        const currentActiveCard = parseInt($('.cart__product').get().map((item, index) => $(item).hasClass('active') ? index : '').join(''));
        $('.cart__products').slick('slickGoTo', currentActiveCard);
        initialRun = true;
    }

    $('.cart__products').on('setPosition', function () {
        if ($(window).width() <= 768) {
            const currentActiveCard = parseInt($('.cart__product').get().map((item, index) => $(item).hasClass('active') ? index : '').join(''));
            const slickActiveCard = parseInt($('.cart__product').get().map((item, index) => $(item).hasClass('slick-center') ? index : '').join(''));
            $('.cart__product').removeClass('active');
            $('.cart__product').eq(currentActiveCard).addClass('active');
            $('.cart__product.active').trigger("click");

            if (slickActiveCard != currentActiveCard) {
                $('.cart__product').removeClass('active');
                $('.cart__product').eq(slickActiveCard).addClass('active');
                $('.cart__product.active').trigger("click");
            }
        }
    });

    $('.cart__products').on('click', function () {
        if ($(window).width() < 768) {
            const currentActiveCard = parseInt($('.cart__product').get().map((item, index) => $(item).hasClass('active') ? index : '').join(''));
            const slickActiveCard = parseInt($('.cart__product').get().map((item, index) => $(item).hasClass('slick-center') ? index : '').join(''));

            if (slickActiveCard != currentActiveCard) {
                $('.cart__products').slick('slickGoTo', currentActiveCard);
            }
        }
    });
}

$('.btn.readMore').on('click', function () {
    setTimeout(function () {
        $('.cart__products').slick("refresh");
        $('.cart__product.active').trigger("click");
    }, 1500);
})
